import { Box, Table, TableContainer } from "@chakra-ui/react";
import React from "react";

/**
 * Rounded, bordered table shell with horizontal scroll on small screens.
 */
export default function DataTable({
  children,
  variant = "premium",
  maxH,
  className = "",
}) {
  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="lg"
      bg="white"
      shadow="xs"
      overflow="hidden"
      className={className}
    >
      <TableContainer maxH={maxH} overflowY={maxH ? "auto" : undefined}>
        <Table variant={variant} size="sm">
          {children}
        </Table>
      </TableContainer>
    </Box>
  );
}
